module.exports = __webpack_public_path__ + "img/paraview.9b2a2f63.svg";